import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { OrderDetails } from "../../orders.types";

export const requestGetOrderDetails = async (
  orderId: string
): Promise<OrderDetails> => {
  return await instance.get(buildUrl(ApiRoutesOrders.OrderDetails, orderId));
};
